__webpack_require__.p = "https://wonderful-rock-025f5b41e.4.azurestaticapps.net/";